import { baseService } from '~/services/base';
import { TFeedback, CreateFeedbackDto, UpdateFeedbackDto, GetFeedbackDto } from '~/types/feedback';
import { ApiResponse } from '~/types/common';

export const feedbackApi = {
  getFeedback: (params: GetFeedbackDto): Promise<ApiResponse<TFeedback>> => {
    return baseService.get('/feedback', { params });
  },

  getFeedbackById: (id: string): Promise<TFeedback> => {
    return baseService.get(`/feedback/${id}`);
  },

  createFeedback: (data: CreateFeedbackDto): Promise<TFeedback> => {
    return baseService.post('/feedback', data);
  },

  updateFeedback: (id: string, data: UpdateFeedbackDto): Promise<TFeedback> => {
    return baseService.patch(`/feedback/${id}`, data);
  },

  deleteFeedback: (id: string): Promise<void> => {
    return baseService.delete(`/feedback/${id}`);
  },
};